import React, { useRef, useState } from 'react';
import StatusBar from '@dataGrid/components/StatusBar';
import DataGrid from '@dataGrid';
import GridHeader from './GridHeader';
import GridConfig from './GridConfig';
import { Alias } from './types';

type AliasesDataGridProps = {
  classes: Record<string, string>;
  aliases: Alias[];
};

// customerCode can repeat (e.g. misc customers), so build a unique row id for AG Grid selection
type AliasRow = Alias & { rowId: string };

const constructStatusBar = (aliases: Alias[]) => [
  {
    label: `${aliases.length} Aliases`
  }
];

const AliasesDataGrid = ({ classes, aliases }: AliasesDataGridProps) => {
  const [quickFilterText, setQuickFilterText] = useState('');
  const [gridApi, setGridApi] = useState<unknown>(null);
  const gridConfig = useRef(new GridConfig());

  const onGridReady = ({ api }: { api: unknown }) => {
    setGridApi(api);
  };

  const rows: AliasRow[] = aliases.map((alias, index) => ({
    ...alias,
    rowId: `${alias.customerCode}-${index}`
  }));

  return (
    <div className={classes.moduleContainer}>
      <div className={`${classes.gridContainer} ${classes.aliasesGridContainer}`}>
        <GridHeader
          classes={classes}
          gridApi={gridApi}
          updateQuickFilterText={setQuickFilterText}
        />
        <div className={`${classes.dataGrid} ${classes.aliasesGrid}`}>
          <DataGrid
            defaultColDef={gridConfig.current.config.defaultColDef}
            columnDefs={gridConfig.current.config.columns}
            config={gridConfig.current.config}
            rowData={rows}
            getRowId={(params: { data: AliasRow }) => params.data.rowId}
            onGridReady={onGridReady}
            quickFilterText={quickFilterText}
            panelLabel={(filteredData: Alias[]) => (
              <StatusBar
                data={constructStatusBar(filteredData)}
                customClass={classes.statusBar}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default AliasesDataGrid;
